 var DateTool = function DateTool(milliseconds){
    if(typeof milliseconds == 'object')
    {
        this._date = milliseconds;
    }
    else this._date =  new Date(milliseconds);

    this.getDate =  function(delimiter="/"){
        let month = this._date.getMonth();
        month = month + 1;
        let year = this._date.getFullYear();
        let day = this._date.getDate();
        let date = this.formatNumber(day) +  delimiter + this.formatNumber(month) + delimiter+ this.formatNumber(year);

        return date;
    };

    this.isToday = () => {
        const today = new Date()
        return  this._date.getDate() == today.getDate() &&
            this._date.getMonth() == today.getMonth() &&
            this._date.getFullYear() ==  today.getFullYear();
    };

    this.isTomorrow = () => {

        const today = new Date()
        const tomorrow = new Date(today)
        tomorrow.setDate(tomorrow.getDate() + 1);

        return  this._date.getDate() == tomorrow.getDate() &&
            this._date.getMonth() == tomorrow.getMonth() &&
            this._date.getFullYear() ==  tomorrow.getFullYear()

    }

    this.getTime = function(delimiter=":"){
        //var delimiter = ":";
        let hours = this._date.getHours();
        let minutes = this._date.getMinutes();
        //let seconds = this._date.getSeconds();

        //let time = this.formatNumber(hours) +  delimiter + this.formatNumber(minutes) + delimiter+ this.formatNumber(seconds);
        let time = this.formatNumber(hours) +  delimiter + this.formatNumber(minutes);
        return time;
    };

    this.toString = function(){

        return this.getDate() + " " + this.getTime();
    };

    this.formatNumber =  function(number){
        number = parseInt(number);
        if(isNaN(number)){
            return "00";
        }

        if(number < 10){
            return "0" + number.toString();
        }
        return number.toString();

    }

    this.convertDate = function() {

        var mins = this._date.getMinutes();
        var hours = this._date.getHours();
        var day = this._date.getDate();
        var month = this._date.getMonth() + 1;
        var year = this._date.getFullYear();

        // Chiamo il servizio per recuperare l'ora corrente   
        var dateTimeNow = Date.now();

        var dayNow = new Date(dateTimeNow).getDate();
        var monthNow = new Date(dateTimeNow).getMonth() + 1;
        var yearNow = new Date(dateTimeNow).getFullYear();

        (hours < 10) ? (hours = "0" + hours) : hours;
        (mins < 10) ? (mins = "0" + mins) : mins;
        (day < 10) ? (day = "0" + day) : day;
        (month < 10) ? (month = "0" + month) : month;

        if (day == dayNow && month == monthNow && year == yearNow)
            var isToday = true;
        else isToday = false;

        var isTomorrow = false;
        // Differenza in giorni. Se pari a 1 è domani
        if (Math.round((milliseconds - dateTimeNow) / (1000 * 60 * 60 * 24)) == 1) isTomorrow = true;

        var stringTime = hours + ":" + mins;

        var stringDate = day + "/" + month + "/" + year;

        var ConvertedDate = {
            StringDate: stringDate,
            StringTime: stringTime,
            IsToday: isToday,
            IsTommorow: isTomorrow
        };
        return ConvertedDate;
    }
}

export default DateTool;